import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CardLinkOffer } from './models/card-link-offer.model';

export interface CardLinkOffersState extends EntityState<CardLinkOffer> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'card-link-offers', idKey: 'OfferId' })
export class CardLinkOffersStore extends EntityStore<CardLinkOffersState> {

  constructor() {
    super();
  }

}
